import React, { useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function CategoriaDialog({ open, onClose, onSubmit, categoria, isLoading }) {
  const [formData, setFormData] = useState({
    nombre: "",
    margen_defecto: 30,
    coste_fijo_defecto: 5,
    activa: true
  });
  const [isAdmin, setIsAdmin] = useState(false);

  /* eslint-disable-next-line no-unused-vars */
  const { user } = useAuth();

  useEffect(() => {
    // Si hay usuario, asumimos admin por ahora para mostrar opciones avanzadas
    setIsAdmin(!!user);
  }, [user]);

  useEffect(() => {
    if (categoria) {
      setFormData(categoria);
    } else {
      setFormData({
        nombre: "",
        margen_defecto: 30,
        coste_fijo_defecto: 5,
        activa: true
      });
    }
  }, [categoria, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle className="text-2xl text-gray-900 dark:text-white">
            {categoria ? "Editar Categoría" : "Nueva Categoría"}
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div>
              <Label htmlFor="nombre" className="dark:text-gray-300">Nombre *</Label>
              <Input
                id="nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                required
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>

            {isAdmin && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="margen" className="dark:text-gray-300">Margen por defecto (%)</Label>
                  <Input
                    id="margen"
                    type="number"
                    step="0.1"
                    value={formData.margen_defecto}
                    onChange={(e) => setFormData({...formData, margen_defecto: parseFloat(e.target.value)})}
                    required
                    className="dark:bg-gray-800 dark:border-gray-700"
                  />
                </div>

                <div>
                  <Label htmlFor="coste" className="dark:text-gray-300">Coste fijo (€)</Label>
                  <Input
                    id="coste"
                    type="number"
                    step="0.01"
                    value={formData.coste_fijo_defecto}
                    onChange={(e) => setFormData({...formData, coste_fijo_defecto: parseFloat(e.target.value)})}
                    required
                    className="dark:bg-gray-800 dark:border-gray-700"
                  />
                </div>
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading} className="bg-indigo-600 hover:bg-indigo-700">
              {isLoading ? "Guardando..." : categoria ? "Actualizar" : "Crear"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}